<template>
	<section>
		<div class="enter registration cover">
			<!-- Outer -->
			<div class="enter__outer">

				<!-- Enter Inner -->
				<div class="enter__inner registration__enter-inner">
					<div class="main-logo registration__logo">
						<img class="main-logo__item" src="../../assets/img/logo.png" alt="logo">
					</div>
				</div>
				<!-- Enter Inner End -->

				<!-- Enter Inner -->
				<div class="enter__inner">
					<form id="entry_form" class="enter-form registration__form" @submit.prevent="submit">
						<input-phone v-show="!resetPassword.isForgot" :user="user"
												 :placeholder="'Введите номер телефона'" required></input-phone>
						<input class="enter-text-field" v-show="!resetPassword.isForgot" v-model="user.password" type="password"
									 placeholder="Пароль">
						<input class="enter-form__button" v-show="!resetPassword.isForgot" type="submit" value="Войти">

						<router-link :to="'/register'">
							<a v-show="!resetPassword.isForgot" class="enter-form__link">Регистрация нового пользователя</a>
						</router-link>

						<div v-show="!resetPassword.isForgot" @click="forgotPassword" class="enter-form__link">
							Забыли пароль?
						</div>

						<div v-show="resetPassword.isForgot">
							<div v-show="resetPassword.steps == 'first'">
								<p class="enter__text">* На указаный номер телефона будет выслан проверочный код</p>

								<input-phone :user="user"></input-phone>

								<input type="button" class="enter-form__button" @click="sendRestorePhoneForRestorePass(user.phone)"
											 value="Отправить">
							</div>


							<div v-show="resetPassword.steps == 'two'">
								<input v-model="confirmCode" type="text" placeholder="Введите код с сообщения" class="enter-text-field">
								<input type="button" class="enter-form__button" @click="sendConfirmationCode(confirmCode)"
											 value="Отправить">
							</div>


							<div v-show="resetPassword.steps == 'three'">
								<input v-model="newPasswords.pass" type="password" placeholder="Введите новый пароль"
											 class="enter-text-field">
								<input v-model="newPasswords.rePass" type="password" placeholder="Повторите ввод"
											 class="enter-text-field">

								<input type="button" class="enter-form__button"
											 @click="changePassword(newPasswords.pass, newPasswords.rePass)"
											 value="Изменить пароль">
							</div>


							<a @click="goToLogin" class="enter-form__link">Назад</a>
						</div>
					</form>
				</div>
				<!-- Enter Inner End -->
			</div>
			<!-- Outer End -->
		</div>
	</section>
</template>

<script>
	import InputPhone from '@/components/InputPhone.vue'

	export default {
		name: 'Login',
		components: {InputPhone},
		data() {
			return {
				resetPassword: {
					isForgot: false,
					steps: 'first'
				},
				confirmCode: '',
				user: {
					phone: '',
					password: ''
				},
				newPasswords: {
					pass: '',
					rePass: ''
				},
				code: ''
			}
		},
		methods: {
			submit() {
				this.$store.dispatch('auth/login', {
					login: this.user.phone,
					password: this.user.password
				}).then(user => {

					if(localStorage.getItem('pageBeforeLogin')) {
						var linkToStart = localStorage.getItem('pageBeforeLogin')
						localStorage.removeItem('pageBeforeLogin')
						this.$router.push(linkToStart)
					} else {
						if(user.workers.length) {
							this.$router.push({
								name: 'Cabinet',
								params: {
									id: user.workers[0]._id
								}
							})
						} else {
							this.$router.push({
								name: 'Cabinet',
								params: {
									id: user._id
								}
							})
						}
					}


				}).catch(error => this.$event.toast('i', 'Номер телефона или пароль не правильный'))
			},
			forgotPassword() {
				this.resetPassword.isForgot = true
				this.resetPassword.steps = 'first'
			},
			goToLogin() {
				this.resetPassword = {
					isForgot: false,
					steps: 'first'
				}

				this.newPasswords = {
					pass: '',
					rePass: ''
				}

				this.user.phone = ''
				this.code = ''
			},
			sendRestorePhoneForRestorePass(phone) {
				if(!phone) {
					this.$event.toast('i', 'Введите номер телефона')
					return false
				}

				this.$api.post('auth/sms/send-code', {
					_scenario: 'password_reset',
					phone: phone
				}).then(() => {
					this.$event.toast('s', 'На телефон +' + phone + ' был отправлен код')
					this.resetPassword.steps = 'two'
				})
			},
			sendConfirmationCode(code) {
				if(!code) {
					this.$event.toast('i', 'Введите код с сообщения')
					return false
				}

				this.$api.post('auth/sms/check-code', {
					phone: this.user.phone,
					code: code,
					_scenario: 'password_reset'
				}).then(() => {
					this.code = code
					this.$event.toast('s', 'Код успешно подтвержден')
					this.resetPassword.steps = 'three'
				})
			},

			changePassword(pass, rePass) {
				if(!pass || !rePass) {
					this.$event.toast('i', 'Заполните все поля')
					return false
				} else if(pass !== rePass) {
					this.$event.toast('i', 'Пароли не совпадают')
					return false
				}

				this.$api.post('auth/reset-password-by-phone', {
					phone: this.user.phone,
					code: this.code,
					password: pass,
					password_confirmation: rePass
				}).then(() => {
					this.$event.toast('s', 'Пароль успешно изменен')
					this.goToLogin()
				})
			}
		}
	}
</script>

<style>

	input.is-danger {
		border-color: red;
	}

	span.is-danger {
		color: rgb(255, 84, 0);
	}

	.entry_form input.is-danger[type="text"],
	.entry_form input.is-danger[type="password"] {
		-webkit-box-shadow: 0 0 0 2px rgb(255, 84, 0);;
		-moz-box-shadow: 0 0 0 2px rgb(255, 84, 0);;
		box-shadow: 0 0 0 2px rgb(255, 84, 0);;
	}

	.register_user_link.info {
		text-decoration: none;
		font-weight: 300;
	}

</style>



// WEBPACK FOOTER //
// Login.vue?1422e9c8